module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am684-a690f2bddf13e4ea693e0558cb15990a.jpg";